<template>
</template>

<script>
import SalesShipmentsPrintPackingListHTML from '@/views/sales/shipments/SalesShipmentsPrintPackingListHTML'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'SalesShipmentsPrintPackingList',
  mixins: [SalesShipmentsPrintPackingListHTML,printHtml],
  props: {
    shipment: {type:Object, required:true}
  },
  async created() {
    this.$emit('done');
    if (!this.shipment)
      return;

    const results = await this.$apiCall(`query SalesShipmentsPrintPackingList($id:ID!) {
                                            shipment(id:$id) {
                                              date,invoice{number},po,shipVia,shipToAddress,billToAddress,memo,draft,pallets
                                              lines {
                                                sku,description,quantity,units,weight,precision,lot
                                                items {sku,description,quantity,units,weight,precision,lot}
                                              }
                                            }
                                            company {name,address,city,province,postalCode,email,phone,logoURL}
                                          }`,
                                        {id:this.shipment.id});
    if (results.error)
      return;
    const company = results.data.company;
    results.data.shipment.invoiceNumber = results.data.shipment.invoice?.number ?? '';
    this.printHtml(`Packing list ${results.data.shipment.invoiceNumber}`,this.print(company, results.data.shipment), company.logoURL ? {id:'logo', src:company.logoURL} : null);
  }
}
</script>